import React, { useState } from 'react';
import { Save, Phone, Mail, Clock, MapPin } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card } from '../ui/card';
import { toast } from 'sonner';

export const BusinessInfoManager = () => {
  const [formData, setFormData] = useState({
    phone: '(305) 772-4150',
    email: 'info@vargastireautorepair.com',
    hours_weekday: '24/7',
    hours_saturday: '24/7',
    hours_sunday: '24/7',
    emergency: '24/7 Roadside Assistance - Anytime, Anywhere'
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // In production, this would save to database
    toast.success('Business information updated!', {
      description: 'Changes will be reflected after page reload'
    });
  };

  return (
    <div className="space-y-6">
      <Card className="p-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">Business Information</h2>
            <p className="text-gray-600">Manage your business contact details and hours</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Contact Information */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
              <Phone className="w-5 h-5" />
              Contact Details
            </h3>
            
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <Label>Phone Number</Label>
                <Input
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  placeholder="(555) 123-4567"
                  className="mt-2"
                />
              </div>
              <div>
                <Label>Email Address</Label>
                <Input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  placeholder="info@vargastireautorepair.com"
                  className="mt-2"
                />
              </div>
            </div>
          </div>

          {/* Business Hours */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
              <Clock className="w-5 h-5" />
              Business Hours
            </h3>
            
            <div className="space-y-3">
              <div>
                <Label>Monday - Friday</Label>
                <Input
                  value={formData.hours_weekday}
                  onChange={(e) => setFormData({...formData, hours_weekday: e.target.value})}
                  placeholder="7:00 AM - 8:00 PM"
                  className="mt-2"
                />
              </div>
              <div>
                <Label>Saturday</Label>
                <Input
                  value={formData.hours_saturday}
                  onChange={(e) => setFormData({...formData, hours_saturday: e.target.value})}
                  placeholder="8:00 AM - 6:00 PM"
                  className="mt-2"
                />
              </div>
              <div>
                <Label>Sunday</Label>
                <Input
                  value={formData.hours_sunday}
                  onChange={(e) => setFormData({...formData, hours_sunday: e.target.value})}
                  placeholder="9:00 AM - 5:00 PM"
                  className="mt-2"
                />
              </div>
            </div>
          </div>

          {/* Emergency Service */}
          <div>
            <Label>Emergency Service Message</Label>
            <Input
              value={formData.emergency}
              onChange={(e) => setFormData({...formData, emergency: e.target.value})}
              placeholder="24/7 Emergency Service Available"
              className="mt-2"
            />
          </div>

          {/* Service Areas */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
              <MapPin className="w-5 h-5" />
              Service Areas
            </h3>
            <div className="space-y-3">
              <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                <p className="font-semibold text-blue-900 mb-2">🌴 South Florida</p>
                <p className="text-xs text-blue-800 leading-relaxed">
                  Miami-Dade, Broward, Palm Beach, Monroe, Collier, Lee, Charlotte, Sarasota, Manatee, Martin, St. Lucie, Indian River, Okeechobee, Hendry, Glades
                </p>
              </div>
              <div className="bg-green-50 p-3 rounded-lg border border-green-200">
                <p className="font-semibold text-green-900 mb-1">🆕 Now Serving North Florida!</p>
                <p className="text-sm text-green-800 font-semibold">New Location: Jacksonville, FL</p>
                <p className="text-xs text-green-700 mt-1">Servicing all of North Florida</p>
              </div>
            </div>
          </div>

          <Button
            type="submit"
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            <Save className="w-4 h-4 mr-2" />
            Save Changes
          </Button>
        </form>
      </Card>

      {/* Instructions */}
      <Card className="p-6 bg-blue-50 border-blue-200">
        <h3 className="text-lg font-semibold text-blue-900 mb-2">Note</h3>
        <p className="text-sm text-blue-800">
          Business information is currently stored in the frontend mockData file. To make these changes persistent, they need to be saved to the database. This feature can be fully implemented if needed.
        </p>
      </Card>
    </div>
  );
};